import Select from './Select';
import {
  SelectMenuDefault,
  SelectLabelDefault,
  DropdownMenuDefault,
  DropdownItemDefault
} from './Select.styles';
import IconToggle from './IconToggle';

export default Select;
export {
  Select,
  SelectMenuDefault,
  SelectLabelDefault,
  DropdownMenuDefault,
  DropdownItemDefault,
  IconToggle as IconDefault
};
